/* eslint-disable react/no-unescaped-entities */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import React, { useCallback, useState } from "react";

import axios from "axios";

import { useMsal } from "@azure/msal-react";

import { ButtonGroup, Table, ToggleButton, ToggleButtonGroup } from "react-bootstrap";

import { b2cPolicies, deployment, loginRequest } from "../../authConfig";
import { useEffect, useMemo } from "react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_Row,
  type MRT_TableOptions,
  MRT_EditActionButtons,
} from "material-react-table";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import * as Yup from "yup";
import { useFormik } from "formik";
import { findSigninAccount } from "../../helpers/hooks/useAccountFinder";
import { Link } from "react-router-dom";
import { RRM_EditCellTextField } from "../../helpers/TextField";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { RRM_EditActionButtons } from "../../helpers/Button";

type IdTokenClaims = {
  roles: string[];
  idp: string;
  email: string;
  signInName: string;
  appTenantName: string;
  sub: string;
  appTenantId: string;
  QuestionId: string;
  acr: any;
};
//example data type
type Member = {
  roles: string;
  tenantId: string;
  userId: string;
  givenName: string;
  surname: string;
  email: string;
  status: string;
  contactNumber: number;
  creationDate: Date;
  fullName: string;
  id: string;
};
interface FormErrors {
  givenName?: string;
  email?: string;
  roles?: string;
  status?: string;
  surname?: string;
  contactNumber: number;
  creationDate: Date;
  fullName: string;

  // Add other fields as needed
}
const queryClient = new QueryClient();

const defaultRoles = [
  {
    label: "Member",
    value: "Tenant.member",
  },
  {
    label: "Admin",
    value: "Tenant.admin",
  },
  {
    label: "Manager",
    value: "Tenant.manager",
  },
];
const defaultStatus = [
  {
    label: "Inactive",
    value: "InActive",
  },
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Re-Send Invitation",
    value: "Invitation Re-Sent",
  },
];
export const UserManagement = () => {
  const [nowShowing, setState] = useState("members");
  const [updatedData, setUpdatedData] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const { instance } = useMsal();
  const accounts = findSigninAccount(instance.getAllAccounts());
  const appTenantId = (accounts[0].idTokenClaims as IdTokenClaims).appTenantId;

  let options = [
    ["members", "Members"],
    ["invitation", "New"],
  ]
    .filter(role)
    .map((v) => (
      <Button key={v[0]} onClick={() => setState(v[0])}>
        {v[1]}
      </Button>
    ));
  function role(option: string[]) {
    if (option[0] === "invitation")
      if (
        (accounts[0]?.idTokenClaims as IdTokenClaims).roles &&
        (accounts[0]?.idTokenClaims as IdTokenClaims)?.roles.includes("Tenant.admin")
      )
        return true;
      else return false;
    //if(option[0] === "myurl")
    //    if (accounts[0].idTokenClaims.idp != 'local') return true; else return false;
    return true;
  }

  return (
    <>
      {/*       <div>
        <ButtonGroup className="mb-2">{options}</ButtonGroup>
      </div> */}
      {nowShowing === "claims" ? (
        <IdTokenContent />
      ) : nowShowing === "members" ? (
        <Members />
      ) : (
        <MyUrl
          domain_hint={(accounts[0]?.idTokenClaims as IdTokenClaims)?.idp}
          login_hint={
            (accounts[0]?.idTokenClaims as IdTokenClaims)?.email ??
            (accounts[0]?.idTokenClaims as IdTokenClaims)?.signInName
          }
          tenant={(accounts[0]?.idTokenClaims as IdTokenClaims)?.appTenantName}
        />
      )}
    </>
  );
};

const IdTokenContent = () => {
  const { accounts } = useMsal();
  const [idTokenClaims, setIdTokenClaims] = useState(accounts[0].idTokenClaims);
  return (
    <>
      <IdTokenClaims idTokenClaims={idTokenClaims as IdTokenClaims} />
    </>
  );
};

const IdTokenClaims = (props: {
  idTokenClaims: {
    email: string;
    signInName: string;
    sub: string;
    appTenantName: string;
    appTenantId: string;
    roles: string[];
    QuestionId: string;
  };
}) => {
  return (
    <>
      <h5 className="card-title">Some token claims</h5>
      <Table>
        <thead>
          <tr key="ix">
            <th>Name</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>Email/sign in name</strong>
            </td>
            <td>{props.idTokenClaims.email ?? props.idTokenClaims.signInName}</td>
          </tr>
          <tr>
            <td>
              <strong>Object id</strong>
            </td>
            <td>{props.idTokenClaims.sub}</td>
          </tr>
          <tr>
            <td>
              <strong>App tenant name</strong>
            </td>
            <td>{props.idTokenClaims.appTenantName}</td>
          </tr>
          <tr>
            <td>
              <strong>App tenant id</strong>
            </td>
            <td>{props.idTokenClaims.appTenantId}</td>
          </tr>
          <tr>
            <td>
              <strong>Role(s)</strong>
            </td>
          </tr>
          <tr>
            <td>
              <strong>QuestionId</strong>
            </td>
            <td>{props.idTokenClaims.QuestionId}</td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

//testing prettier

const Members = () => {
  //console.log("Members: " + props);
  const [statusList, setStatusList] = useState(defaultStatus);

  const [members, setMembers] = useState<Member[]>([]);
  const [data, setData] = useState<Member[]>([]);
  const { instance } = useMsal();
  const accounts = findSigninAccount(instance.getAllAccounts());
  //const account = accounts[0];
  //const accounts = instance.getAllAccounts(); //here deliberately get all accounts
  const myUserId = (accounts[0].idTokenClaims as IdTokenClaims).sub;
  const [validationErrors, setValidationErrors] = useState<Record<string, string | undefined>>({});
  const [showAdd, setShowAdd] = useState(false);
  const validateRequired = (value: string) => !!value.length;
  const validateExistingEmail = (email: string) => {
    console.log("fetchedUsers: " + JSON.stringify(fetchedUsers));
    if (fetchedUsers.some((m) => m.email === email)) {
      return false;
    }
    return true;
  };
  const validateEmail = (email: string) => {
    return (
      !!email.length &&
      email
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    );
  };
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [emailEditing, setEmailEditing] = useState(true);
  function validateUser(user: Member, mode: string) {
    return {
      givenName: !validateRequired(user.givenName) ? "First Name is Required" : "",
      surname: !validateRequired(user.surname) ? "Last Name is Required" : "",
      roles: !validateRequired(user.roles) ? "Role is Required" : "",
      email: !validateEmail(user.email)
        ? "Incorrect Email Format"
        : mode === "C" && !validateExistingEmail(user.email)
        ? "Email already exists"
        : "",
    };
  }
  const handleAddClick = () => {
    setShowAdd(true);
  };
  const handleOrgClick = () => {
    window.location.href = "/get-started";
  };
  const handleClose = () => {
    setShowAdd(false);
  };
  const validationSchema = Yup.object({
    email: Yup.string().required("Email is required"),
    givenName: Yup.string().required("First Name is required"),
    // Add validations for other fields as needed
  });
  const columns = useMemo<MRT_ColumnDef<Member>[]>(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "System Id",
      },
      {
        accessorKey: "userId", //access nested data with dot notation
        header: "User Id",
      },
      {
        accessorKey: "creationDate", // access nested data with dot notation
        header: "Added On",
        size: 100,
        Cell: ({ row }) => {
          const creationDate = new Date(row.original.creationDate);
          const formattedDate = creationDate.toLocaleDateString("en-AU", {
            day: "numeric",
            month: "short",
            year: "numeric",
          });
          return formattedDate;
        },
        muiEditTextFieldProps: {
          type: "text",
          disabled: true, // assuming creation date is not editable
        },
      },
      // {
      //   accessorKey: "fullName",
      //   header: "Full Name",
      //   Cell: ({ row }) => {
      //     const fullName = `${row.original.givenName} ${row.original.surname}`;
      //     return fullName;
      //   },
      //   size: 150,
      //   muiEditTextFieldProps: {
      //     type: "text",
      //     required: true,
      //     error: !!validationErrors?.givenName,
      //     helperText: validationErrors?.givenName,
      //     //remove any previous validation errors when user focuses on the input
      //     onFocus: () =>
      //       setValidationErrors({
      //         ...validationErrors,
      //         givenName: undefined,
      //       }),
      //     //optionally add validation checking for onBlur or onChange
      //   },
      // },
      {
        accessorKey: "givenName", //access nested data with dot notation
        header: "First Name",
        size: 100,
        muiEditTextFieldProps: {
          type: "text",
          required: true,
          error: !!validationErrors?.givenName,
          helperText: validationErrors?.givenName,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              givenName: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "surname", //access nested data with dot notation
        header: "Last Name",
        size: 100,
        muiEditTextFieldProps: {
          type: "text",
          required: true,
          error: !!validationErrors?.surname,
          helperText: validationErrors?.surname,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              surname: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "email", //access nested data with dot notation
        header: "Email",
        size: 150,
        muiEditTextFieldProps: ({ cell, row, table }) => ({
          type: "email",
          required: true,
          error: !!validationErrors?.email,
          helperText: validationErrors?.email,
          onLoad: () => {
            console.log("Loading EMail", row.original.status);
            if (row.original.status !== "Invitation Sent") {
              setEmailEditing(false);
            } else {
              setEmailEditing(true);
            }
          },
          onChange: () => {
            console.log("Loading EMail", row.original.status);
            if (row.original.status !== "Invitation Sent") {
              setEmailEditing(false);
            } else {
              setEmailEditing(true);
            }
          },
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              email: undefined,
            }),
        }),
      },
      {
        accessorKey: "contactNumber", // access nested data with dot notation
        header: "Contact Number",
        size: 150,
        muiEditTextFieldProps: {
          type: "tel",
          required: true,
          error: !!validationErrors?.contactNumber,
          helperText: validationErrors?.contactNumber,
          // remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              contactNumber: undefined,
            }),
          // optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "roles", //access nested data with dot notation
        header: "Role",
        size: 100,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            {renderedCellValue ? <ListRoles roles={row.original.roles} /> : <></>}
          </Box>
        ),
        editVariant: "select",
        editSelectOptions: defaultRoles,
        muiEditTextFieldProps: {
          select: true,
          error: !!validationErrors?.roles,
          helperText: validationErrors?.roles,
        },
      },
      {
        accessorKey: "status", //access nested data with dot notation
        header: "Status",
        size: 100,
        editVariant: "select",
        editSelectOptions: statusList,
        muiEditTextFieldProps: {
          select: true,
          error: !!validationErrors?.status,
          helperText: validationErrors?.status,
        },
      },
    ],
    [validationErrors]
  );
  //READ hook (get users from api)
  function useGetUsers() {
    return useQuery<Member[]>({
      queryKey: ["members"],
      queryFn: async () => {
        //send api request here
        // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
        const appTenantId = (accounts[0]?.idTokenClaims as IdTokenClaims)?.appTenantId;
        let response = axios.get(
          `${process.env.REACT_APP_API_SERVER}/rm/user/getAllUsersForTenant/` + appTenantId
        );

        return (await response).data;
      },
      refetchOnWindowFocus: false,
    });
  }
  function useCreateUser() {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async (user: Member) => {
        //send api update request here
        await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
        return Promise.resolve();
      },
      //client side optimistic update
      onMutate: async (newUserInfo: Member) => {
        let request = {
          authority: b2cPolicies.authorities.signIn.authority,
          scopes: loginRequest.scopes,
          account: accounts[0],
          extraQueryParameters: {
            tenant: (accounts[0].idTokenClaims as IdTokenClaims).appTenantName,
          },
        };
        let isAdminFlag = "false";
        let role = "";
        if (newUserInfo.roles == "Tenant.admin") {
          isAdminFlag = "true";
        }
        console.log("user roles", newUserInfo.roles, newUserInfo.roles[0]);
        const myEmail = fetchedUsers.find(
          (m) => m.userId === (accounts[0].idTokenClaims as IdTokenClaims).sub
        )?.email;
        await axios
          .post(`${process.env.REACT_APP_API_SERVER}/rm/b2cpolicies/tenant/oauth2/invite`, {
            inviteEmail: newUserInfo.email,
            additionalClaims: {
              isAdmin: newUserInfo.roles,
              appTenantRole: newUserInfo.roles,
            },
            user: newUserInfo,
            adminName: myEmail,
          })
          .then((response) => {
            console.log("invite received", response);
          })
          .catch((error) => console.log(error));

        let response = await axios.post(`${process.env.REACT_APP_API_SERVER}/rm/user/createUser`, {
          givenName: newUserInfo.givenName,
          surname: newUserInfo.surname,
          email: newUserInfo.email,
          tenantId: (accounts[0].idTokenClaims as IdTokenClaims).appTenantId,
          roles: [newUserInfo.roles],
          userId: "",
          status: "Invitation Sent",
        });
        console.log(response);
        if (response.status !== 201) {
          alert("Error creating user");
          return;
        }

        let userId = (await response).data.id;

        queryClient.setQueryData(
          ["members"],
          (prevUsers: any) =>
            [
              ...prevUsers,
              {
                ...newUserInfo,
                userId: userId,
                roles: [newUserInfo.roles],
                creationDate: new Date(),
              },
            ] as Member[]
        );
      },
      // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
  }
  //UPDATE action
  const handleSaveUser: MRT_TableOptions<Member>["onEditingRowSave"] = async ({
    values,
    table,
    row,
  }) => {
    const newValidationErrors = validateUser(values, "E");
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    console.log("Compare row and values", row.original, values);
    if (row.original.status === "Invitation Sent" && values.status === "Active") {
      setAlertMessage("User has not accepted the invitation yet. Cannot activate user manually.");
      setShowAlert(true);
      return;
    }
    if (row.original.status === "Invitation Sent" && values.status === "InActive") {
      setAlertMessage(
        "User has not accepted the invitation yet. Cannot in-activate user manually."
      );
      setShowAlert(true);
      return;
    }
    values["userId"] = row.original.userId;
    values["id"] = row.original.id;
    if (values.status === "InActive") {
      const appTenantId = (accounts[0]?.idTokenClaims as IdTokenClaims)?.appTenantId;
      const policyActionsResponse = await axios.get(
        `${process.env.REACT_APP_API_SERVER}/rm/policy/control/actions/${appTenantId}`
      );

      //check if the userId is present on any active actions
      const policyActions = policyActionsResponse.data.filter((action: PolicyActionEntity) => {
        return (
          action.isActive && (action.owner === values.userId || action.manager === values.userId)
        );
      });
      console.log("policyActions", policyActions);
      if (policyActions.length > 0) {
        setAlertMessage("User has active actions. Cannot deactivate user.");
        setShowAlert(true);
        return;
      }
    }
    setValidationErrors({});
    setAlertMessage("");
    setShowAlert(false);
    console.log("Row", JSON.stringify(row.original));
    await updateUser(values);
    table.setEditingRow(null); //exit editing mode
  };
  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<Member>) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      deleteUser(row.original.userId);
    }
  };
  //UPDATE hook (put user in api)
  function useUpdateUser() {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async (user: Member) => {
        //send api update request here
        await new Promise<void>(async (resolve) => {
          console.log(user);
          let userRole: string[] = [];
          if (user.roles[0].toLowerCase().includes("admin")) {
            userRole = ["Tenant.admin"];
          }
          if (user.roles[0].toLowerCase().includes("member")) {
            userRole = ["Tenant.member"];
          }
          if (user.roles[0].toLowerCase().includes("manager")) {
            userRole = ["Tenant.manager"];
          }
          if (user.status === "Invitation Sent" || user.status === "Invitation Re-Sent") {
            console.log("in invitation ", accounts[0]);
            let request = {
              authority: b2cPolicies.authorities.signIn.authority,
              scopes: loginRequest.scopes,
              account: accounts[0],
              extraQueryParameters: {
                tenant: (accounts[0].idTokenClaims as IdTokenClaims).appTenantName,
              },
            };
            let isAdminFlag = "false";
            let role = "";
            if (user.roles == "Tenant.admin") {
              isAdminFlag = "true";
            }
            console.log("user roles", user.roles, userRole);
            const myEmail = fetchedUsers.find(
              (m) => m.userId === (accounts[0].idTokenClaims as IdTokenClaims).sub
            )?.email;
            await axios
              .post(`${process.env.REACT_APP_API_SERVER}/rm/b2cpolicies/tenant/oauth2/invite`, {
                inviteEmail: user.email,
                additionalClaims: { isAdmin: userRole[0], appTenantRole: userRole[0] },
                user: user,
                adminName: myEmail,
              })
              .then((response) => {
                console.log("invite received", response);
              })
              .catch((error) => console.log(error));
          } else if (user.status === "InActive") {
            try {
              let responseInactive = await axios.put(
                `${process.env.REACT_APP_API_SERVER}/rm/b2cpolicies/tenant/member`,
                {
                  userId: user.userId,
                  status: user.status,
                }
              );
            } catch (e) {
              alert("Error deactivating user");
              console.log(e);
              return;
            }
          } else if (user.status === "Active") {
            try {
              let responseInactive = await axios.put(
                `${process.env.REACT_APP_API_SERVER}/rm/b2cpolicies/tenant/member`,
                {
                  userId: user.userId,
                  status: user.status,
                }
              );
            } catch (e) {
              alert("Error reactivating user");
              console.log(e);
              return;
            }
          }

          let response = await axios.put(
            `${process.env.REACT_APP_API_SERVER}/rm/user/saveUserById`,
            {
              email: user.email,
              tenantId: (accounts[0].idTokenClaims as IdTokenClaims).appTenantId,
              status: user.status,
              givenName: user.givenName,
              surname: user.surname,
              userId: user.userId,
              id: user.id,
              roles: userRole,
              contactNumber: user.contactNumber,
            }
          );
          resolve(); // Resolve the outer promise
        }); //fake api call
        return Promise.resolve();
      },
      //client side optimistic update
      onMutate: (newUserInfo: Member) => {
        /*         if (newUserInfo.roles === "Tenant.admin") {
          newUserInfo.roles = "Admin";
        }
        if (newUserInfo.roles === "Tenant.member") {
          newUserInfo.roles = "Member";
        }
        if (newUserInfo.roles === "Tenant.manager") {
          newUserInfo.roles = "Manager";
        } */
        //newUserInfo.roles = mapRole(newUserInfo.roles);
        queryClient.setQueryData(["members"], (prevUsers: any) =>
          prevUsers?.map((prevUser: Member) =>
            prevUser.userId === newUserInfo.userId ? newUserInfo : prevUser
          )
        );
        console.log("New USer Inf", newUserInfo);
      },
      // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
  }
  //DELETE hook (delete user in api)
  function useDeleteUser() {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async (userId: string) => {
        //send api update request here
        await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
        return Promise.resolve();
      },
      //client side optimistic update
      onMutate: (userId: string) => {
        queryClient.setQueryData(["members"], (prevUsers: any) =>
          prevUsers?.filter((user: Member) => user.userId !== userId)
        );
      },
      // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
  }
  //call CREATE hook
  const { mutateAsync: createUser, isPending: isCreatingUser } = useCreateUser();
  //call READ hook
  const {
    data: fetchedUsers = [],
    isError: isLoadingUsersError,
    isFetching: isFetchingUsers,
    isLoading: isLoadingUsers,
  } = useGetUsers();

  //call UPDATE hook
  const { mutateAsync: updateUser, isPending: isUpdatingUser } = useUpdateUser();
  //call DELETE hook
  const { mutateAsync: deleteUser, isPending: isDeletingUser } = useDeleteUser();
  //CREATE action
  const handleCreateUser: MRT_TableOptions<Member>["onCreatingRowSave"] = async ({
    values,
    table,
  }) => {
    const newValidationErrors = validateUser(values, "C");
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    console.log("new Validation Errors: " + JSON.stringify(newValidationErrors));
    setValidationErrors({});
    values["status"] = "Invitation Sent";
    await createUser(values);
    table.setCreatingRow(null); //exit creating mode
  };
  const table = useMaterialReactTable({
    columns,
    data: fetchedUsers, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    createDisplayMode: "modal", //default ('row', and 'custom' are also available)
    editDisplayMode: "modal", //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,
    positionActionsColumn: "last",
    getRowId: (row) => row.userId,
    mrtTheme: (theme) => ({
      baseBackgroundColor: theme.palette.background.default,
      boxShadow: "none !important",
      borderRadius: "none !important",
    }),
    muiTableBodyRowProps: {
      hover: false,
      sx: {
        whiteSpace: "nowrap",
      },
    },
    muiTablePaperProps: {
      sx: {
        boxShadow: "none !important",
        // width: "1187px",
        // minWidth: "1187px",
      },
    },
    muiTableProps: {
      sx: {
        // border: "1px solid rgba(81, 81, 81, .5)",
        boxShadow: "none !important",
        whiteSpace: "nowrap",
        borderRadius: "none !important",
      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #EDEDED",
        // borderLeft: "1px solid rgba(81, 81, 81, .5)",
        // borderTop: "1px solid rgba(81, 81, 81, .5)",
        // fontStyle: "italic",
        fontWeight: "bold",
        fontSize: "14px",
        whiteSpace: "nowrap",
        textAlign: "center",
        boxShadow: "none",
        paddingLeft: "20px",
        backgroundColor: "#FBFBFF",
        color: "#111827 60%",
        height: "50px",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        borderBottom: "1px solid rgba(81, 81, 81, .5)",
        // whiteSpace: "pre-wrap",
        // paddingLeft: "20px",
        // paddingRight: "20px",
        paddingTop: "10px",
        paddingBottom: "10px",
        border: "1px solid #EDEDED",
        // borderLeft: columns.accessorKey === "status" ? "none" : "1px solid #EDEDED",
      },
    },
    muiToolbarAlertBannerProps: isLoadingUsersError
      ? {
          color: "error",
          children: "Error loading data",
        }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "100px",
      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between", // Aligns items with space between them
            alignItems: "center", // Aligns items vertically
            padding: "15px",
            backgroundColor: "white",
          }}
        >
          {/* <Button component={Link} to="/get-started" variant="contained" color="primary">
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
            >
              Add Organisation
            </Typography>
          </Button> */}
        </Box>
        {/* <Button
          variant="contained"
          onClick={() => {
            table.setCreatingRow(true); //simplest way to open the create row modal with no default values
          }}
        >
          Add User
        </Button>
        // <Button component={Link} to="/get-started" variant="contained" color="primary">
        //   <Typography
        //     variant="h6"
        //     noWrap
        //     component="div"
        //     sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
        //   >
        //     Add Organisation
        //   </Typography>
        // </Button>
        <Button component={Link} to="/Organisation" variant="contained" color="primary">
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
          >
            Organisation Settings
          </Typography>
        </Button>
        <Button component={Link} to="/SystemSettings" variant="contained" color="primary">
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
          >
            System Settings
          </Typography>
        </Button> */}
      </>
    ),
    onCreatingRowCancel: () => {
      setValidationErrors({});
      setAlertMessage("");
      setShowAlert(false);
    },
    onCreatingRowSave: handleCreateUser,
    onEditingRowCancel: () => {
      setValidationErrors({});
      setAlertMessage("");
      setShowAlert(false);
    },
    onEditingRowSave: handleSaveUser,
    //optionally customize modal content
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <Dialog
          open={true}
          onClose={() => table.setEditingRow(null)}
          fullWidth={true}
          maxWidth={"md"}
        >
          {" "}
          <DialogTitle variant="h3">Add User</DialogTitle>
          <DialogContent
            sx={{ display: "flex", flexDirection: "column", gap: "1.5rem", width: "100%" }}
          >
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <RRM_EditCellTextField row={row} accessKey="givenName" table={table} />
            </Box>
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <RRM_EditCellTextField row={row} accessKey="surname" table={table} />
            </Box>
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <RRM_EditCellTextField row={row} accessKey="email" table={table} />
            </Box>
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <RRM_EditCellTextField row={row} accessKey="roles" table={table} />
            </Box>
          </DialogContent>
          <DialogActions>
            <RRM_EditActionButtons variant="text" table={table} row={row} />
          </DialogActions>
        </Dialog>
      </>
    ),
    //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <Dialog
        open={true}
        onClose={() => table.setEditingRow(null)}
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle variant="h3">Edit User</DialogTitle>{" "}
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: "1.5rem", width: "100%" }}
        >
          {showAlert && <Alert severity="error">{alertMessage}</Alert>}
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <RRM_EditCellTextField row={row} accessKey="givenName" table={table} />
          </Box>
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <RRM_EditCellTextField row={row} accessKey="surname" table={table} />
          </Box>
          <Box sx={{ display: "flex", gap: "1rem" }}>
            {row.original.status === "Invitation Sent" ? (
              <RRM_EditCellTextField row={row} accessKey="email" table={table} />
            ) : (
              <RRM_EditCellTextField row={row} accessKey="email" table={table} editable={false} />
            )}
          </Box>
          {row.original.userId === myUserId ? (
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <RRM_EditCellTextField row={row} accessKey="roles" table={table} editable={false} />
            </Box>
          ) : (
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <RRM_EditCellTextField row={row} accessKey="roles" table={table} />
            </Box>
          )}
          {row.original.userId === myUserId ? (
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <RRM_EditCellTextField row={row} accessKey="status" table={table} disabled />
            </Box>
          ) : (
            <Box sx={{ display: "flex", gap: "1rem" }}>
              <RRM_EditCellTextField row={row} accessKey="status" table={table} />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <RRM_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </Dialog>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <Box sx={{ display: "flex", gap: "20px", alignItems: "center", paddingRight: "10px" }}>
        <Button
          variant="contained"
          onClick={() => {
            table.setCreatingRow(true); //simplest way to open the create row modal with no default values
          }}
        >
          Add User
        </Button>
      </Box>
    ),
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Edit">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    state: {
      isLoading: isLoadingUsers,
      isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
      showAlertBanner: isLoadingUsersError,
      showProgressBars: isFetchingUsers,
    },
    initialState: {
      //optional initial state
      columnVisibility: {
        id: false,
        userId: false,
      },
    },
  });
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "15px",
          backgroundColor: "#F9F9FB",
          height: "100%",
        }}
      >
        <Box sx={{ backgroundColor: "white", borderRadius: "15px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
              padding: "10px",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Manrope",
                fontSize: "14px",
                fontWeight: 600,
                lineHeight: "19.12px",
                textAlign: "left",
                color: "#111827",
              }}
            >
              Account Management
            </Typography>
          </Box>
          <div style={{ flex: 1 }}>
            {data ? (
              <div>
                <MaterialReactTable table={table} />
              </div>
            ) : (
              <p>Loading, please wait...</p>
            )}
          </div>
        </Box>
      </Box>
    </>
  );
};

const mapRole = (role: string) => {
  if (role[0] === "Tenant.member") return "Member";
  if (role[0] === "Tenant.admin") return "Admin";
  if (role[0] === "Tenant.manager") return "Manager";
  if (role === "Tenant.member") return "Member";
  if (role === "Tenant.admin") return "Admin";
  if (role === "Tenant.manager") return "Manager";
  return role;
};

const ListRoles = (props: { roles: string }) => {
  return <>{mapRole(props.roles)}</>;
};

const MyUrl = (props: { login_hint: any; domain_hint: string; tenant: string }) => {
  console.log(props);
  const lh = props.login_hint;
  const url =
    "https://aka.ms/mtb2c?domain_hint=" +
    props.domain_hint +
    "&login_hint=" +
    lh +
    "&tenant=" +
    props.tenant;
  return (
    <>
      <h5>Use this url to speed up your sign in next time:</h5>
      <p>{url}</p>
    </>
  );
};

const UserManagementWithProviders = () => (
  //Put this with your other react-query providers near root of your app
  <QueryClientProvider client={queryClient}>
    <UserManagement />
  </QueryClientProvider>
);
export default UserManagementWithProviders;
